import React from 'react'
import { useSelector } from 'react-redux';
import SarasWrapper from '../../container/SarasWrapper'
import ActionButton from '../../input/buttons/button/SarasButton';
import SarasConfirmPrompt from "../../notifications/SarasConfirmPrompt";
import { compareNumber } from '../../../helper/uiFunctions';

const FormActionButton = (props) => { 
    //this should be default format for reading props for all form controls
    const {formObject, action, rowKey, headerKey, customWrapper, 
        starIconClassName, className,
        disableToHide, text, confirm, ...restProps} = props;

    const [confirmPromptData,setConfirmPromptData] = React.useState({})
    const viewData = formObject.getFormData(rowKey, headerKey, action.paramName);
    let hide = formObject.getValueFromKey(viewData, "dataList.isHid", "0");
    const label = formObject.getValueFromKey(viewData, "dataList.label", text);

    var disableActionState = useSelector(state => state.formState);
    var disableFormActions = false;

    if (disableActionState != null){
        // console.log("form action button read", formObject.formStateKey, disableActionState[formObject.formStateKey] ? true : false);
        disableFormActions = disableActionState[formObject.formStateKey] ? true : false;
    }
    
    if (disableToHide && compareNumber(hide, 1)) {
        disableFormActions = true;
        hide = "0"; //reset hide option so that disable will work
    }

    // console.log("hide", hide, disableToHide, disableFormActions);

    const onButtonClick = (e) => {
        // console.log("form button clicked");
        if(confirm && confirm.length > 0)
        {
            setConfirmPromptData({message:confirm, callback:executeButtonAction});
        }
        else{
            executeButtonAction()
        }
    }

    const executeButtonAction = ()=>{
        let customAction = {...action}

        //reset the confirm dialog
        setConfirmPromptData({});
        // console.log("create copy before transform", customAction, action.actionParam);

        if(action.actionParam){
            let params = formObject.getDependantValue(action.actionParam, rowKey, headerKey, action.paramName)
            customAction.actionParam = {...params};
        }

        if(customAction.actionId === "next_step"){
            customAction.actionId = "import";
        }

        // console.log("create copy", customAction);

        //execute switch action if view switch is also configured
        if(action.viewSwitch && formObject.viewSwitcher) formObject.viewSwitcher.onUpdateTriggerKey(customAction.viewSwitch); 
        //send the parameters reqired by the form
        if(action.actionId) formObject.onFormAction(customAction, rowKey, headerKey);
    }

    const getText = () => {
        if(viewData)
            return label || viewData.valF || text;
        else
            return text
    }


    //if hide is 1 it means do not render, if hide is missing or is 0 it means do not hide
    if(compareNumber(hide, 0)){
        return (
            <SarasWrapper customWrapper={customWrapper}>
                <SarasConfirmPrompt promptData={confirmPromptData} />
                <ActionButton
                    starIconClassName={starIconClassName || "uiBrandColor1"}
                    showText={1} 
                    disabled={disableFormActions}
                    onClick={onButtonClick}
                    {...restProps}
                    className={`uiContentCenter uiButtonAppText2 ${className}`}>
                    <span className='uiAppText2Compliment'>{getText()}</span>
                </ActionButton>
            </SarasWrapper>
        )
    }

    return (null);
}

export default FormActionButton;
